import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Step,
  StepLabel,
  Stepper
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
];

const ErrorStep = () => {
  const isStepFailed = (step) => {
    return step === 1;
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Error step
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              " const steps = [\n" +
              '  "Select campaign settings",\n' +
              '  "Create an ad group",\n' +
              '  "Create an ad",\n' +
              "];" +
              "" +
              "              <Stepper activeStep={1}>\n" +
              "                {steps.map((label, index) => {\n" +
              "                  const labelProps = {};\n" +
              "                  if (isStepFailed(index)) {\n" +
              "                    labelProps.optional = (\n" +
              '                      <Typography variant="caption" color="error">\n' +
              "                        Alert message\n" +
              "                      </Typography>\n" +
              "                    );\n" +
              "\n" +
              "                    labelProps.error = true;\n" +
              "                  }\n" +
              "\n" +
              "                  return (\n" +
              "                    <Step key={label}>\n" +
              "                      <StepLabel {...labelProps}>{label}</StepLabel>\n" +
              "                    </Step>\n" +
              "                  );\n" +
              "                })}\n" +
              "              </Stepper>\n"
            }
          >
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={1}>
                {steps.map((label, index) => {
                  const labelProps = {};
                  if (isStepFailed(index)) {
                    labelProps.optional = (
                      <Typography variant="caption" color="error">
                        Alert message
                      </Typography>
                    );

                    labelProps.error = true;
                  }

                  return (
                    <Step key={label}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ErrorStep;
